import styled from '@emotion/styled'
import { MainFrameBG } from '../../../pure-js/libs/Colors'
import { TextKeys } from '../../../pure-js/libs/Texts'
import { TextKeyWithOnlyText } from '../../../pure-js/types/Antiloop'
import { BorderRadixes } from '../enums/BorderRadixes'
import { getFigmaText } from '../libs/TextRepository'
import Box from './Box'
import Button from './Button'
import FigmaText from './FigmaText'
import Tooltip from './Tooltip'

export const SectionHeaderAndCTA = ({
  headerTextKey,
  descriptionTextKey,
  ctaTextKey,
  tooltipTextKey,
  onClick
}: {
  headerTextKey: TextKeyWithOnlyText
  descriptionTextKey: TextKeyWithOnlyText
  tooltipTextKey: TextKeyWithOnlyText
  ctaTextKey: TextKeyWithOnlyText
  onClick: () => unknown
}) => {
  return (
    <Container fullWidth fullPadding>
      <Box fullWidth>
        <Box>
          <FigmaText textKey={TextKeys.dashboardOverallCollaborationSectionHeader} text={getFigmaText(headerTextKey)} />
        </Box>
        <Box top>
          <FigmaText
            textKey={TextKeys.dashboardOverallCollaborationEmptyState}
            text={getFigmaText(descriptionTextKey)}
          />
        </Box>
      </Box>
      <Box top fullWidth align="center">
        <Box>
          <Tooltip title={getFigmaText(tooltipTextKey)}>
            <Button buttonType="secondary" text={getFigmaText(ctaTextKey)} onClick={onClick} />
          </Tooltip>
        </Box>
      </Box>
    </Container>
  )
}

const Container = styled(Box)`
  border-radius: ${BorderRadixes.big};
  background-color: ${MainFrameBG};
`
